import { language as lan_stepProductContent } from "./bulk-order-checkout-product-content";
import { language as lan_stepProductTip } from "./bulk-order-checkout-product-tip";
import { language as lan_stepShippingContent } from "./bulk-order-checkout-shipping-content";
import { language as lan_stepShippingTip } from "./bulk-order-checkout-shipping-tip";
import { language as lan_stepPaymentContent } from "./bulk-order-checkout-payment-content";
import { language as lan_stepPaymentTip } from "./bulk-order-checkout-payment-tip";

let language = {
    ...lan_stepProductContent,
    ...lan_stepProductTip,
    ...lan_stepShippingContent,
    ...lan_stepShippingTip,
    ...lan_stepPaymentContent,
    ...lan_stepPaymentTip,

    BULK_ORDER_CHECKOUT_NEXT_STEP_BTN: "下一步",
    BULK_ORDER_CHECKOUT_BACK_STEP_BTN: "返回",
    BULK_ORDER_CHECKOUT_CANCEL_BTN: "取消",
    BULK_ORDER_CHECKOUT_GO_PAYMENT_BTN: "前往支付",

    BULK_ORDER_CHECKOUT_STEP_PRODUCT: "产品",
    BULK_ORDER_CHECKOUT_STEP_SHIPPING: "运输",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT: "付款",
};

export { language }
